module.exports = __webpack_public_path__ + "img/edit-profile.babe40d2.svg";